(() => {
  const CONFIG_SELECTOR = '[data-psp-product-enquiry-context]';
  const FORM_HOST_SELECTOR = 'shopify-forms-embed';
  const DEFAULT_FIELD_ID = 'custom#interested_in';
  const MAX_WAIT_MS = 15000;
  const RETRY_INTERVAL_MS = 100;
  const FORM_READY_DELAY_MS = 500;

  const setControlledInputValue = (input, value) => {
    const valueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value'
    )?.set;

    if (valueSetter) {
      valueSetter.call(input, value);
    } else {
      input.value = value;
    }

    input.dispatchEvent(
      new InputEvent('input', {
        bubbles: true,
        composed: true,
        data: value,
        inputType: 'insertText',
      })
    );
    input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  };

  const contextValue = (config) => {
    const title = config.dataset.productTitle?.trim();
    const url = config.dataset.productUrl?.trim();

    return [title, url].filter(Boolean).join(' — ');
  };

  const ensureProductContext = (input, value, productUrl) => {
    const existingValue = input.value.trim();

    if (existingValue.includes(productUrl)) return;

    setControlledInputValue(
      input,
      existingValue ? `${value} — ${existingValue}` : value
    );
  };

  const populateForm = (config) => {
    const host = config.querySelector(FORM_HOST_SELECTOR);
    const root = host?.shadowRoot;
    const fieldId = config.dataset.productFieldId || DEFAULT_FIELD_ID;
    const input = root?.getElementById(fieldId);
    const value = contextValue(config);
    const productUrl = config.dataset.productUrl?.trim();

    if (!(input instanceof HTMLInputElement) || !value || !productUrl) return false;

    ensureProductContext(input, value, productUrl);
    input.dataset.pspProductContext = 'populated';

    const form = input.form;
    if (form && !form.dataset.pspProductContextBound) {
      form.dataset.pspProductContextBound = 'true';
      form.addEventListener(
        'submit',
        () => {
          ensureProductContext(input, value, productUrl);
        },
        true
      );
    }

    return true;
  };

  const initialise = (config) => {
    if (config.dataset.pspProductContextInitialised) return;
    config.dataset.pspProductContextInitialised = 'true';

    let fieldDetectedAt = 0;

    const populateWhenReady = () => {
      const host = config.querySelector(FORM_HOST_SELECTOR);
      const root = host?.shadowRoot;
      const fieldId = config.dataset.productFieldId || DEFAULT_FIELD_ID;
      const input = root?.getElementById(fieldId);

      if (!(input instanceof HTMLInputElement)) {
        fieldDetectedAt = 0;
        return false;
      }

      if (!fieldDetectedAt) {
        fieldDetectedAt = Date.now();
        return false;
      }

      if (Date.now() - fieldDetectedAt < FORM_READY_DELAY_MS) return false;

      return populateForm(config);
    };

    const retryInterval = window.setInterval(() => {
      if (populateWhenReady()) window.clearInterval(retryInterval);
    }, RETRY_INTERVAL_MS);

    window.setTimeout(() => {
      window.clearInterval(retryInterval);
      if (!populateWhenReady()) {
        console.warn(
          'PSP product enquiry context was not populated. The Shopify Forms field may be unavailable.'
        );
      }
    }, MAX_WAIT_MS);
  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll(CONFIG_SELECTOR).forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
